export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/bank-cheque-icon.a94728c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};